import { Box, Typography } from '@mui/material';
import React from 'react';
import { T } from '../../theme/tokens';

export interface ToolbarButtonProps {
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  badge?: number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  variant = 'secondary', disabled = false, badge, onClick, children,
}) => {
  const isPrimary = variant === 'primary';
  return (
    <Box
      component="button"
      disabled={disabled}
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 32,
        px: '14px',
        gap: badge !== undefined ? '6px' : 0,
        border: disabled
          ? `1px solid ${T.border}`
          : isPrimary
            ? `1px solid ${T.ink}`
            : `1px solid ${T.borderInput}`,
        bgcolor: disabled ? 'transparent' : isPrimary ? T.ink : 'transparent',
        color: disabled ? T.textFaint : isPrimary ? T.bg : T.text,
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '0.02em',
        borderRadius: '2px',
        outline: 'none',
        transition: 'background-color 120ms ease, border-color 120ms ease',
        WebkitFontSmoothing: 'antialiased',
        '&:hover:not(:disabled)': {
          bgcolor: isPrimary ? T.text : T.surfaceAlt,
        },
        '&:focus-visible': {
          outline: `1px solid ${T.ink}`,
          outlineOffset: 0,
        },
      }}
    >
      {children}
      {badge !== undefined && (
        <>
          <Box sx={{ width: 1, height: 16, bgcolor: isPrimary ? 'rgba(250,248,245,0.3)' : T.borderInput, mx: '4px' }} />
          <Typography component="span" sx={{ fontSize: 11, fontWeight: 500, color: 'inherit' }}>
            {badge}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default ToolbarButton;
